<template>
  <div class="c-study-left-nav">
    <ul class="c-study-left-nav-items">
      <li class="c-study-left-nav-item">
        <div class="c-study-left-nav-item-icon">
          <i class="iconfont icon-zhuxingtu"></i>
        </div>
        <p>章节</p>
        <div class="c-study-left-nav-item-content">
          <ul class="c-study-left-nav-item-chapters" v-if="chapters.length">
            <li class="c-study-left-nav-item-chapter" v-for="(chapter, chapterIndex) in chapters" :key="`chapter-${chapterIndex}`">
              <p class="c-study-left-nav-item-chapter-title">{{chapter.title}}</p>
              <ul class="c-study-left-nav-item-segments">
                <li @click="$emit('changeCurrent', segment, segmentIndex, chapter, chapterIndex)" class="c-study-left-nav-item-segment" v-for="(segment, segmentIndex) in chapter.listdata" :key="`segment-${segmentIndex}`">
                  <i class="iconfont icon-sj-2 c-study-left-nav-item-segment-play"></i>
                  {{chapterIndex | indexToNumbering}}-{{segmentIndex | indexToNumbering}} {{segment.title}}
                  <span class="c-study-left-nav-item-segment-state" :class="[segment.lostatus === 1 ? 'c-study-left-nav-item-segment-state-done' : '', segment.isCurrent ? 'c-study-left-nav-item-segment-state-doing' : '']"></span>
                </li>
                <li v-if="chapter.onstatus" @click="$emit('switchToTopic', chapter, chapterIndex)" class="c-study-left-nav-item-segment">
                  <i class="iconfont icon-zj c-study-left-nav-item-segment-play"></i>
                  阶段测试
                  <span class="c-study-left-nav-item-segment-state" :class="[chapter.exstatus === 1 ? 'c-study-left-nav-item-segment-state-done' : '', chapterIndex == current.chapterIndex ? 'c-study-left-nav-item-segment-state-doing' : '']"></span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </li>
      <li class="c-study-left-nav-item" v-if="downloads">
        <div class="c-study-left-nav-item-icon">
          <i class="iconfont icon-other"></i>
        </div>
        <p>资料</p>
        <div class="c-study-left-nav-item-content">
          <ul class="c-study-left-nav-item-content-download text-overflow">
            <li v-for="(file, fileIndex) in downloads" :key="fileIndex">
              <span>{{file.fileext | getFileType}}</span>
              {{file.title}}
              <a target="_blank" :href="file.fileurl">下载</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    chapters: {
      type: Array,
      default: null
    },
    current: {
      type: Object,
      default: null
    },
    downloads: {
      type: Array,
      default: null
    }
  },
  filters: {
    indexToNumbering (val) {
      return val * 1 + 1
    },
    getFileType (val) {
      if (val.match(/\/\w+\.gif/)) {
        return val.match(/\/\w+\.gif/)[0].replace('.gif', '').replace('/', '')
      } else {
        return '文件'
      }
    }
  },
}
</script>

<style lang="scss">
  .c-study-left-nav{
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    padding-top: 115px;
    background-color: #272727;
    width: 65px;
    z-index: 5;
    .c-study-left-nav-items{
      .c-study-left-nav-item{
        height: 74px;
        font-size: 15px;
        color: #FFFFFF;
        text-align: center;
        box-sizing: border-box;
        border-top: 1px solid transparent;
        cursor: pointer;
        .c-study-left-nav-item-icon{
          margin: 0 auto;
          margin-top: 17px;
          line-height: 22px;
          max-width: 30px;
          .iconfont{
            font-size: 20px;
          }
        }
        p{
          line-height: 20px;
        }
        &:hover .c-study-left-nav-item-content{
          display: block;
          opacity: 1;
        }
        .c-study-left-nav-item-content{
          width: 400px;
          height: 100%;
          padding-top: 85px;
          background-color: #fff;
          left: 65px;
          z-index: 4;
          position: absolute;
          top: 0;
          display: none;
          opacity: 0;
          transition: all .3s;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          max-height: 100%;
          overflow-y: auto;
          padding-bottom: 100px;
          box-sizing: border-box;
          .c-study-left-nav-item-chapters{
            padding: 0 20px;
            .c-study-left-nav-item-chapter{
              margin-bottom: 30px;
              .c-study-left-nav-item-chapter-title{
                line-height: 19px;
                font-size: 14px;
                color: #212121;
                font-weight: 700;
                text-align: left;
                margin-bottom: 9px;
              }
              .c-study-left-nav-item-segments{
                .c-study-left-nav-item-segment{
                  text-align: left;
                  font-size: 12px;
                  line-height: 28px;
                  height: 28px;
                  color: #5D6064;
                  padding-left: 25px;
                  margin-bottom: 5px;
                  position: relative;
                  &:nth-last-child(1){
                    margin-bottom: 0;
                  }
                  &:hover{
                    background-color: #F9F9F9;
                  }
                  .c-study-left-nav-item-segment-play{
                    position: absolute;
                    left: 8px;
                    top: 0;
                    line-height: 28px;
                    font-size: 12px;
                  }
                  .c-study-left-nav-item-segment-state{
                    width: 6px;
                    height: 6px;
                    border: 2px solid #CACDD2;
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    border-radius: 50%;
                  }
                  .c-study-left-nav-item-segment-state-done{
                    background-color: #29C23D;
                    border-color: #29C23D;
                  }
                  .c-study-left-nav-item-segment-state-doing{
                    border-color: #29C23D;
                    background-color: transparent;
                  }
                }
              }
            }
          }
          .c-study-left-nav-item-content-download{
            padding: 0 20px;
            li{
              padding-right: 50px;
              padding-left: 42px;
              position: relative;
              line-height: 25px;
              font-size: 13px;
              height: 25px;
              overflow: hidden;
              margin-bottom: 14px;
              text-align: left;
              color: #5D6064;
              line-height: 25px;
              &:hover{
                color: #29C23D;
                a{
                  background-color: #29C23D;
                  color: white;
                }
              }
              span{
                position: absolute;
                display: block;
                left: 0;
                top: 1.5px;
                font-size: 12px;
                height: 22px;
                line-height: 22px;
                border-radius: 11px;
                width: 36px;
                color: white;
                background-color: #DBDBDB;
                text-align: center;
              }
              a{
                position: absolute;
                top: 0;
                right: 0;
                color: white;
                display: block;
                text-align: center;
                line-height: 25px;
                height: 25px;
                text-decoration: none;
                width: 46px;
                border-radius: 13px;
                color: #29C23D;
                transition: all .3s;
              }
            }
          }
        }
        &:hover{
          background-color: rgba(255,255,255,.08);
        }
      }
    }
  }
</style>
